import { ApiType, ApiUrls } from '@/config/api';
import { request } from '../utils/axios';

/**************************************** 视频管理start ******************************************/
/** 分页查询 */
export const createCloudVideo = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_CREATE_CLOUD_VIDEO,
    data: params,
  });

  return res;
};
/** 归档视频数据 */
export const createCloudVideoArchiving = async (params: { id: number }) => {
  const res = await request({
    method: 'get',
    apiType: ApiType.API_CREATECLOUD_ARCHIVING,
    params,
  });

  return res;
};
/** 删除 */
export const createCloudVideoDelete = async (params: { id: number }) => {
  const res = await request({
    method: 'get',
    apiType: ApiType.API_CREATECLOUD_DELETE,
    params,
  });

  return res;
};
/**************************************** 视频管理start ******************************************/

/**************************************** 邀请管理start ******************************************/

/** 分页查询 */
export const invitListPage = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_INVIT_LIST_PAGE,
    data: params,
  });

  return res;
};

/** 查询 */
export const invitListPageSearch = async (params: { id: number }) => {
  const res = await request({
    url: `${ApiUrls[ApiType.API_INVIT_LIST_PAGE_SEARCH]}/${params.id}`,
  });

  return res;
};

/** 修改 */
export const invitUpdate = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_INVIT_UPDATE,
    data: params,
  });

  return res;
}
/** 新增 */
export const invitAdd = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_INVIT_ADD,
    data: params,
  });

  return res;
}
/** 批量发送 */
export const invitSend = async (params: { ids: number[], selectAll?: boolean }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_INVIT_SEND,
    data: params,
  });

  return res;
}

/** 删除 */
export const invitDelete = async (params: { id: number }) => {
  const res = await request({
    method: 'get',
    apiType: ApiType.API_INVIT_DELETE,
    params,
  });
  return res;
}



/**************************************** 邀请管理end ******************************************/

/**************************************** 流程管理start ******************************************/

/** 分页查询流程 */
export const processPageFlow = async (params: { flowStatus: 0 | 1, current: number, size: number }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_PAGE_FLOW,
    data: params,
  });
  return res;
}
/** 分配审核员 */
export const processAddAuditor = async (params: { flowName: string, flowTypeCode: string, flowTypeName: string }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_ADD_AUDITOR,
    data: params,
  });
  return res;
}
/** 初始化流程 */
export const processInitFlow = async (params: { flowName: string, flowTypeCode: string, flowTypeName: string }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_INIT_FLOW,
    data: params,
  });
  return res;
}
/** 发布流程 撤销流程 */
export const processPublishFlow = async (params: { flowId: string, flowStatus: 0 | 1 }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_PUBLISH_FLOW,
    data: params,
  });
  return res;
}
/** 查询流程详情 */
export const processQueryFlow = async (params: { id: string }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_QUERY_FLOW,
    data: params,
  });
  return res;
}
/** 根据环节查询节点 */
export const processQueryNode = async (params: { id: string }) => {
  const res = await request({
    method: 'get',
    apiType: ApiType.API_PROCESS_QUERY_NODE,
    params,
  });
  return res;
}
/** 暂存/提交流程 */
export const processFlowSave = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_FLOW_SAVE,
    data: params,
  });
  return res;
}
/** 更新流程 */
export const processFlowUpdate = async (params: any) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_PROCESS_FLOW_UPDATE,
    data: params,
  });
  return res;
}
/**************************************** 流程管理end ******************************************/



/**************************************** 审核管理start ******************************************/

/** 商户数量统计 */
export const auditCount = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_COUNT,
  });
  return res;
}

/** 分页查询审核任务 */
export const auditPageTask = async (params: {
  classifyId?: number,
  classifyPId?: number,
  current?: number,
  size?: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_PAGE_TASK,
    data: params,
  });
  return res;
}

/** 分页查询审核任务-线下核身 */
export const auditPageTaskOffline = async (params: {
  classifyId?: number,
  classifyPId?: number,
  current?: number,
  size?: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_PAGE_TASK_OFFLINE,
    data: params,
  });
  return res;
}

/** 分页查询审核任务-已AI审核商户 */
export const auditPageTaskAiAudit = async (params: {
  classifyId?: number,
  classifyPId?: number,
  current?: number,
  size?: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_PAGE_TASK_AI_AUDIT,
    data: params,
  });
  return res;
}

/** 分页查询审核任务-已人工审核商户 */
export const auditPageTaskManual = async (params: {
  classifyId?: number,
  classifyPId?: number,
  current?: number,
  size?: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_PAGE_TASK_MANUAL,
    data: params,
  });
  return res;
}

/** 审核任务详情 */
export const auditTaskDetail = async (params: {
  id: number,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_TASK_DETAIL,
    data: params,
  });
  return res;
}

/** 提交审核结果 */
export const auditResult = async (params: {
  auditRemark: string,
  auditResult: number,
  taskId: number,
  inviteCode: string,
  reviewStartTime: number,
  scoreList: {
    nodeId: string,
    score: string,
    relatedDocumentTypeCode: string,
    reviewLegalRep?: 'Y' | 'N',
  }[],
  totalScore: string | number,
  videoVerifyNeeded: 'Y' | 'N',
  userId: string,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_RESULT,
    data: params,
  });
  return res;
}

/** 分页查询紧急任务 */
export const auditPageUrgentTask = async (params: {
  auditUserId: string,
  current: number,
  expireTime?: string,
  size: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_PAGEURGENTTASK,
    data: params,
  });
  return res;
}

/** 查询首页数据统计 */
export const countIndexData = async () => {
  const res = await request({
    method: 'get',
    apiType: ApiType.API_INDEX_COUNTINDEXDATA,
  });
  return res;
}

/** 获取自定义分数options */
export const scoreList = async (params: {
  typeCode: string;
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_GETSCORELIST,
    data: params,
  });
  return res;
}

/** 获取服务器当前时间戳 */
export const getCurrentTimeMillis = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUDIT_GET_CURRENT_TIME_MILLIS,
  });
  return res;
}


/**************************************** 审核管理end ******************************************/


/**************************************** 数智人管理start ******************************************/

/** 新增数智人分类 */
export const digitalAddClassify = async (params: {
  name: string,
  pid: number
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_ADD_CLASSIFY,
    data: params,
  });
  return res;
}
/** 新增数智人视频 */
export const digitalAddVideo = async (params: {
  videoClassifyId?: string,
  videoClassifyName?: string,
  videoFileId?: string,
  videoTitle?: string,
  videoPrompt?: string,
  digitalVideoTips: string,
  videoMakeTaskId: string,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_ADD_VIDEO,
    data: params,
  });
  return res;
}
/** 修改数智人视频 */
export const digitalEditVideo = async (params: {
  id: string,
  videoClassifyId?: string,
  videoClassifyName?: string,
  videoFileId?: string,
  videoTitle?: string,
  videoPrompt?: string,
  digitalVideoTips: string,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_EDIT_VIDEO,
    data: params,
  });
  return res;
}
/** 数智人视频列表 */
export const digitalPageVideo = async (params: {
  classifyList: (string | number)[],
  current?: number,
  size?: number,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_PAGE_VIDEO,
    data: params,
  });
  return res;
}
/** 查询分类树 */
export const digitalQueryClassifytree = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_QUERY_CLASSIFYTREE,
  });
  return res;
}
/** 删除数智人分类 */
export const digitalDeleteClassify = async (params: { id: number }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_DELETE_CLASSIFY,
    data: params,
  });
  return res;
}
/** 删除数智人视频 */
export const digitalDeleteVideo = async (params: { id: string }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DIGITAL_DELETE_VIDEO,
    data: params,
    hideTip: true,
  });
  return res;
}
/**************************************** 数智人管理end ******************************************/

/**************************************** 文件操作start ******************************************/
/** 文件上传 */
export const fileUpload = async (params: FormData, data: {
  storage?: 'PUBLIC' | 'PRIVATE', // 存储类型,PUBLIC:公读,PRIVATE:私读,
  userId?: string,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_FILE_UPLOAD,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: data,
    hideTip: true,
  });
  return res;
}

/**************************************** 文件操作end ******************************************/

/**************************************** 登录start ******************************************/
/** 用户登录 */
export const authLogin = async (params: { token: string }) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUTH_LOGIN,
    data: params,
  });
  return res;
}
/** 用户登出 */
export const authLoginOut = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUTH_LOGINOUT,
  });
  return res;
}
/** 验证用户登录状态 */
export const authVerifylogin = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUTH_VERIFYLOGIN,
    hideTip: true,
  });
  return res;
}
/** 获取用户信息 */
export const authUserInfo = async () => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_AUTH_GETUSERINFO,
  });
  return res;
}
/**************************************** 登录end ******************************************/


/**************************************** 字典数据start ******************************************/
type DictParams = {
  dictEnCode: string,
  dictName: string,
  dictValue: string,
  status: 1 | 0,
  description?: string,
  dictDisplayType?: string,
}
/** 新增字典 */
export const dictAdd = async (params: DictParams) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DICT_ADD,
    data: params,
  });
  return res;
}
/** 删除字典 */
export const dictDelete = async (params: { id: number }) => {
  const res = await request({
    method: 'post',
    // apiType: ApiType.API_DICT_DELETE,
    url: `${ApiUrls[ApiType.API_DICT_DELETE]}/${params.id}`,
  });
  return res;
}
/** 分页查询字典 */
export const dictPage = async (params: {
  current: number,
  dictName: string,
  size: number,
}) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DICT_PAGE,
    data: params,
  });
  return res;
}
/** 修改字典 */
export const dictUpdate = async (params: DictParams) => {
  const res = await request({
    method: 'post',
    apiType: ApiType.API_DICT_UPDATE,
    data: params,
  });
  return res;
}
/** 根据字典id获取字典详情 */
export const dictDesc = async (params: { id: number }) => {
  const res = await request({
    method: 'get',
    url: `${ApiUrls[ApiType.API_DICT_DESC]}/${params.id}`,
  });
  return res;
}
/** 根据字典分组类型查询字典集合 */
export const dictSearchDisplayType = async (params: { type: string }) => {
  const res = await request({
    method: 'get',
    url: `${ApiUrls[ApiType.API_DICT_SEARCH_DISPLAY_TYPE]}/${params.type}`,
  });
  return res;
}
/**************************************** 字典数据end ******************************************/


export interface QuestionPageParams {
  classifyList?: number[];
  current?: number;
  size?: number;
}
export function questionPage(params: QuestionPageParams) {
  return request({
    method: 'post',
    data: params,
    apiType: ApiType.API_QUESTION_PAGE,
  });
}

export function questionCategoryTree() {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_CATEGORY_TREE,
  });
}

export function questionCreateCategory(name: string, pid?: string) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_CATEGORY_CREATE,
    data: {
      name,
      pid,
    },
  });
}

export function questionDeleteCategory(id: string) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_CATEGORY_DELETE,
    data: {
      id,
    },
  });
}

export function questionDelete(id: string) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_DELETE,
    data: {
      id,
    },
  });
}

export function randomGenerationQuestion(params: {
  classifyId: string;
  count: number;
}) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_RANDOM_GENERATION_QUESTION,
    data: params
  });
}

export interface QuestionPayload {
  answerContent: string;
  classifyId?: string;
  digitalVideoId?: string;
  digitalVideoTips?: string;
  digitalVideoTitle?: string;
  digitalVideoUrl?: string;
  pid: number;
  questionContent?: string;
  levelId: string;
  subQuestions?: QuestionPayload[];
}

export function questionCreate(payload: QuestionPayload) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_CREATE,
    data: payload,
  });
}

export function questionUpdate(payload: QuestionPayload & { id: string }) {
  return request({
    method: 'post',
    apiType: ApiType.API_QUESTION_UPDATE,
    data: payload,
  });
}

/**音视频制作进度查询**/
export function getProgress(payload: { id: string }) {
  return request({
    method: 'post',
    apiType: ApiType.API_VIDEOMAKER_GETPROGRESS,
    data: payload,
  });
}
/**音视频制作**/
export function videoMakeAdvanced(payload: { inputSsml: string }) {
  return request({
    method: 'post',
    apiType: ApiType.API_VIDEOMAKER_VIDEOMAKEADVANCED,
    data: payload,
  });
}
/**数字人形象预览**/
export function videoPreview() {
  return request({
    method: 'post',
    apiType: ApiType.API_VIDEOMAKER_VIDEOPREVIEW,
  });
}
